  <section class="header-btn-wrapper">
    <button type="button" (click)="AddFaq()" class="btn btn-primary my-main-button lg-button"><i class="fas fa-fw fa-plus"></i> Add New Faq</button>
  </section>
  <ag-grid-angular
  #agGrid
  domLayout='autoHeight'
  class="ag-theme-alpine"
  [rowData]="faqs"
  [columnDefs]="columnDefs"
  rowSelection="multiple"
  [defaultColDef]="defaultColDef"
  [pagination]="true"
  [suppressRowClickSelection]="true"
  (gridReady)="onGridReady($event)"
  (firstDataRendered)="onFirstDataRendered($event)"
  [enableCellTextSelection]="true"

>
</ag-grid-angular>